// Othellos-specific UI chrome (match screen, dialogue/subtitle hints, board
// aria-labels) that isn't part of the shared gamzone shell's i18n.ts table.
// Same t(key, vars)/useT() shape as gamzone/i18n.ts, scoped to this game.

import { getLanguage, useLang } from "../../gamzone/i18n.ts";

const STRINGS = {
  ko: {
    pause: "일시정지",
    toMap: "맵으로",
    victory: "승리",
    draw: "무승부",
    defeat: "패배",
    continueBtn: "계속",
    watchAd: "광고보기",
    adRewardNote: "광고보기를 하시면 {points} 포인트가 적립됩니다.",
    duelEnd: "결투 종료",
    moveCounter: "{n}수 / 빈칸 {empty}",
    me: "나",
    turnSkipped: "{who} 차례 건너뜀",
    tapContinue: "탭하여 계속",
    tapStart: "탭하여 게임 시작",
    nextLine: "다음 대사",
    duelStart: "결투 시작",
    prevAct: "이전 막",
    nextAct: "다음 막",
    thanksForPlaying: "이용해 주셔서 감사합니다.",
    boardAria: "8x8 오델로 보드",
    cellFilled: "{row}행 {col}열 {color}",
    cellPlayable: "{row}행 {col}열 착수 가능",
    cellEmpty: "{row}행 {col}열 빈칸",
    discDark: "흑",
    discLight: "백",
    friendMatchTitle: "친구랑 같이하기",
    myTurn: "당신 차례예요.",
    opponentTurn: "상대 차례예요.",
    opponent: "상대",
  },
  en: {
    pause: "Paused",
    toMap: "To map",
    victory: "Victory",
    draw: "Draw",
    defeat: "Defeat",
    continueBtn: "Continue",
    watchAd: "Watch ad",
    adRewardNote: "Watching an ad earns you {points} points.",
    duelEnd: "Duel over",
    moveCounter: "Move {n} · {empty} left",
    me: "Me",
    turnSkipped: "{who}'s turn skipped",
    tapContinue: "Tap to continue",
    tapStart: "Tap to start",
    nextLine: "Next line",
    duelStart: "Start duel",
    prevAct: "Previous act",
    nextAct: "Next act",
    thanksForPlaying: "Thank you for playing.",
    boardAria: "8x8 Othello board",
    cellFilled: "Row {row}, column {col}, {color}",
    cellPlayable: "Row {row}, column {col}, playable",
    cellEmpty: "Row {row}, column {col}, empty",
    discDark: "black",
    discLight: "white",
    friendMatchTitle: "Friend Match",
    myTurn: "Your turn.",
    opponentTurn: "Opponent's turn.",
    opponent: "Opponent",
  },
} as const;

type Key = keyof (typeof STRINGS)["ko"];

export function gt(key: Key, vars: Record<string, string | number> = {}): string {
  const lang = getLanguage();
  const template = STRINGS[lang][key] ?? STRINGS.ko[key];
  return template.replace(/\{(\w+)\}/g, (_, name) => `${vars[name] ?? ""}`);
}

/** React hook: gt() bound to the current locale (re-renders on change). */
export function useGt(): typeof gt {
  useLang();
  return gt;
}
